import { Flex } from "@radix-ui/themes";
import type { Market } from "@src/api";
import { Text } from "@src/ui-kit";
import { useStores } from "@stores";
import { memo } from "react";
import { MarketItemPercent } from "./MarketItemPercent";
import { MarketItemPrice } from "./MarketItemPrice";
import { MarketCard, TokenIcon } from "./styles";
import type { DisplayMode } from "./types";

interface FavoriteMarketItemProps {
  marketAddress: string;
  baseSymbol: string;
  symbol: string;
  token: { icon: string };
  displayMode: DisplayMode;
  onClick: (m: Market) => void;
}

// Static item component wrapped in memo - icon and label never re-render
export const FavoriteMarketItem = memo(
  ({ marketAddress, baseSymbol, symbol, token, displayMode, onClick }: FavoriteMarketItemProps) => {
    const { marketStore } = useStores();

    const handleClick = () => {
      const market = marketStore.allMarkets.find((m) => m.addr === marketAddress);
      if (market) {
        onClick(market);
      }
    };

    return (
      <MarketCard onClick={handleClick}>
        <Flex align="center" gap="6px">
          {token && (
            <TokenIcon data-testid={`favorite-markets:item:${marketAddress}:icon`} alt={symbol} src={token.icon} />
          )}
          <Text data-testid={`favorite-markets:item:${marketAddress}:symbol`} font="body14" weight="medium">
            {baseSymbol}
          </Text>
          {displayMode === "price" ? (
            <MarketItemPrice marketAddress={marketAddress} />
          ) : (
            <MarketItemPercent marketAddress={marketAddress} />
          )}
        </Flex>
      </MarketCard>
    );
  },
);
